(function () {
  function initCarousel(root) {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');

    function scrollByCard(dir) {
      const item = track.querySelector('.product-carousel__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || '20');
      const distance = (item.getBoundingClientRect().width + gap) * dir;
      track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    function updateArrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
})();
